export const onlyText = (v) =>
  v.replace(/[0-9@#$%^&*()_+=[\]{};':"\\|<>/]/g, "");
export const onlyNumbers = (v) => v.replace(/[^0-9]/g, "");
export const onlyPhone = (v) => v.replace(/[^0-9+\s\-()]/g, "");

export const validateNome = (v) => {
  if (!v.trim()) return "Campo obbligatorio";
  if (/[0-9]/.test(v)) return "Non può contenere numeri";
  if (v.trim().length < 2) return "Minimo 2 caratteri";
  return "";
};

export const validateEmail = (v) => {
  if (!v.trim()) return "Campo obbligatorio";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return "Email non valida";
  return "";
};

export const validatePhone = (v) => {
  if (!v.trim()) return "";
  if (!/^[+]?[\d\s\-()]{6,20}$/.test(v)) return "Numero non valido";
  return "";
};

export const validateLinkedin = (v) => {
  if (!v.trim()) return "";
  const clean = v.toLowerCase().replace(/^https?:\/\//, "");
  if (
    !clean.startsWith("linkedin.com/") &&
    !clean.startsWith("www.linkedin.com/")
  ) {
    return "Deve essere un profilo LinkedIn (es. linkedin.com/in/nome)";
  }
  return "";
};

export const validatePeriodo = (v) => {
  if (!v.trim()) return "";
  const mesi =
    "gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic|gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre";
  const anno = "\\d{4}";
  const fine = `((${mesi})\\s+${anno}|${anno}|corrente|oggi|presente|current)`;
  const inizio = `((${mesi})\\s+${anno}|${anno})`;
  const regex = new RegExp(`^${inizio}\\s*[–\\-—]\\s*${fine}$`, "i");
  if (!regex.test(v.trim()))
    return "Es: Gen 2020 – Dic 2023  oppure  2020 – Oggi";
  return "";
};

export const validateAnno = (v) => {
  if (!v.trim()) return "";
  if (!/^\d{4}$/.test(v)) return "Anno a 4 cifre (es. 2020)";
  const n = parseInt(v);
  if (n < 1950 || n > new Date().getFullYear() + 5) return "Anno fuori range";
  return "";
};

export const validateVoto = (v) => {
  if (!v.trim()) return "";
  if (!/^\d{2,3}(\/\d{2,3})?L?$/.test(v)) return "Es: 110/110 oppure 28/30";
  return "";
};
